Object.defineProperty(exports, "__esModule", { value: true });
exports.validateNotInferableField = exports.inferTypeOrThrow = exports.resolveTypeOrThrow = void 0;
const Field_1 = require("../Field");
const typeResolvers_1 = require("../../../services/utils/gql/types/typeResolvers");
const parseNative_1 = require("../../../services/utils/gql/types/parseNative");
function resolveTypeOrThrow(type, target, fieldName) {
    const resolvedType = typeResolvers_1.resolveType(type);
    if (!resolvedType) {
        throw new Field_1.FieldError(target, fieldName, `Explicit type is incorrect. Make sure to use either native graphql type or class that is registered with @Type decorator`);
    }
    return resolvedType;
}
exports.resolveTypeOrThrow = resolveTypeOrThrow;
function throwIfNotInferableType(inferedType, target, fieldName) {
    if (typeof inferedType === 'function') {
        const stringSignature = inferedType.toString();
        if (stringSignature.match(
        // previously we've been comparing tho these functions directly, but this would fail in environments where for example Promise was monkeypatched
        /function (Object|Array|Promise)\(\) { \[native code\] }/)) {
            throw new Field_1.FieldError(target, fieldName, `Field type was infered as "${inferedType}" so it's required to explicitly set the type as it's not possible to guess it. Pass it in a config for the field like: @Field({ type: ItemType })`);
        }
    }
}
function inferTypeOrThrow(target, fieldName) {
    const inferedType = parseNative_1.inferTypeByTarget(target.prototype, fieldName);
    if (!inferedType) {
        throw new Field_1.FieldError(target, fieldName, `Could not infer return type and no type is explicitly configured. In case of circular dependencies make sure to explicitly set a type.`);
    }
    throwIfNotInferableType(inferedType, target, fieldName);
    return typeResolvers_1.resolveType(inferedType);
}
exports.inferTypeOrThrow = inferTypeOrThrow;
function validateNotInferableField(target, fieldName) {
    const inferedType = parseNative_1.inferTypeByTarget(target.prototype, fieldName);
    throwIfNotInferableType(inferedType, target, fieldName);
    return true;
}
exports.validateNotInferableField = validateNotInferableField;
//# sourceMappingURL=fieldType.js.map